export default __webpack_public_path__ + "static/media/Group 1285Yono@2x.b3c7584d.png";